(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive('ngDropdownMultiselect', ngDropdownMultiselect);

    function ngDropdownMultiselect() {
        return {
            templateUrl: '/app/directives/ng-dropdown-multiselect.tpl.html',
            scope: {
                selectedModel: '=',
                options: '=',
                disableDropdown: '=',
                extraSettings: '=',
                events: '=',
            },
            controller: NgDropdownMultiselectController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, element, attr, ctrl, transclude) {
                scope.dropdownTrigger = element.children()[0];
            }
        };
    }

    function NgDropdownMultiselectController($scope, $document, $translate) {
        var vm = this;
        
        vm.settings = {
            displayProp: 'name',
            idProp: 'id',
            enableSearch: true,
            showUncheckAll: true
            
        };
        angular.extend(vm.settings, vm.extraSettings || []);

        vm.getButtonText = getButtonText;
        vm.getPropertyForObject = getPropertyForObject;
        vm.isChecked = isChecked;
        vm.setSelectedItem = setSelectedItem;
        vm.toggleDropdown = toggleDropdown;
        vm.uncheckAll = uncheckAll;
        
        _initialize();

        function _getFindObj(id) {
            var findObj = {};

            findObj[vm.settings.idProp] = id;
            
            return findObj;
        }

        function _initialize() {
            $document.on('click', function (e) {
                var target = e.target.parentElement;
                var parentFound = false;

                while (angular.isDefined(target) && target !== null && !parentFound) {
                    if (_.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                        if (target === $scope.dropdownTrigger) {
                            parentFound = true;
                        }
                    }
                    target = target.parentElement;
                }

                if (!parentFound) {
                    $scope.$apply(function () {
                        vm.open = false;
                    });
                }
            });
        }

        function getButtonText() {
            
            var buttonText = vm.extraSettings.selectTitle || $translate.instant('select');

            if (vm.disableDropdown) return buttonText;

            if (vm.selectedModel.length > 0 || (angular.isObject(vm.selectedModel) && _.keys(vm.selectedModel).length > 0)) {
                var totalSelected = angular.isDefined(vm.selectedModel) ? vm.selectedModel.length : 0;
                
                if (totalSelected > 0) {
                    buttonText = totalSelected + ' ' + $translate.instant('selected');
                }
            }

            return buttonText;
        }

        function getPropertyForObject(object, property) {
            if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                return object[property];
            }
            return '';
        }

        function isChecked(id) {
            return _.findIndex(vm.selectedModel, _getFindObj(id)) !== -1;
        }

        function setSelectedItem(id, dontRemove) {

            var findObj = _getFindObj(id);
            var finalObj = null;

            finalObj = _.find(vm.options, findObj);
                        
            dontRemove = dontRemove || false;

            var exists = _.findIndex(vm.selectedModel, findObj) !== -1;

            if (!dontRemove && exists) {
                vm.selectedModel.splice(_.findIndex(vm.selectedModel, findObj), 1);
            } else if (!exists) {
                vm.selectedModel.push(finalObj);
            }
        }

        function toggleDropdown() {
            vm.open = !vm.open;
        }

        function uncheckAll() {
            vm.selectedModel.splice(0, vm.selectedModel.length);
        }
    }
})();